import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import topTitle from '@/components/title';
import { messageLogDetail } from './request';
export default {
  data() {
    return {
      insuranceInfoData: {},
      tabValue: 'INTERNAL_MAIL',
      columns: [],
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      },
      baseColumn: [{
        dataIndex: 'customerName',
        slots: {
          title: '客户名称'
        },
        width: 80,
        scopedSlots: {
          customRender: 'customerName'
        },
        align: 'center'
      }, {
        dataIndex: 'name',
        slots: {
          title: '账号名称'
        },
        customRender: (text, record) => {
          return text || '-';
        },
        width: 120,
        align: 'center'
      }],
      dataSource: {
        INTERNAL_MAIL: [],
        NOTE: [],
        EMAIL: []
      },
      mapStatus: {
        PROCESSING: '处理中',
        SUCCESS: '处理成功',
        FAIL: '处理失败',
        PENDING: '待处理',
        CANCEL: '取消处理'
      },
      readNumber: '',
      pushMethod: '',
      btnGroup: []
    };
  },
  components: {
    topTitle
  },
  watch: {
    tabValue: {
      handler(val) {
        this.pagination.current = 1;
        this.pagination.pageSize = 10;
        if (val === 'INTERNAL_MAIL') {
          this.columns = [...this.baseColumn, {
            dataIndex: 'readingStatus',
            slots: {
              title: '阅读状态'
            },
            width: 120,
            align: 'center',
            customRender: (text, record) => {
              return this.$t(text) || '-';
            }
          }];
        } else if (val === 'NOTE') {
          this.columns = [...this.baseColumn, {
            align: 'center',
            dataIndex: 'mobile',
            slots: {
              title: '手机号'
            },
            width: 120
          }];
        } else if (val === 'EMAIL') {
          this.columns = [...this.baseColumn, {
            dataIndex: 'email',
            align: 'center',
            slots: {
              title: '邮箱'
            },
            width: 120
          }];
        }
        if (val) {
          this.pagination.total = this.dataSource[val].length;
        }
      },
      immediate: true
    }
  },
  created() {
    this.pushMethod = '';
    this.getDetail();
  },
  methods: {
    handleStandardTableChange(pagination) {
      this.pagination = pagination;
    },
    async getDetail() {
      const {
        messageEventInfo,
        messageDetail,
        readNumber,
        pushMethod,
        messageConfig
      } = await messageLogDetail({
        messageEventId: this.$route.params.id
      });
      messageConfig && Array.isArray(messageConfig) && messageConfig.forEach(item => {
        if (item === 'INTERNAL_MAIL') {
          this.btnGroup.push({
            name: '站内信',
            value: 'INTERNAL_MAIL'
          });
        } else if (item === 'NOTE') {
          this.btnGroup.push({
            name: '短信',
            value: 'NOTE'
          });
        } else if (item === 'EMAIL') {
          this.btnGroup.push({
            name: '邮件',
            value: 'EMAIL'
          });
        }
      });
      if (messageConfig && Array.isArray(messageConfig) && messageConfig.length > 0) {
        this.tabValue = messageConfig[0];
      }
      this.pushMethod = pushMethod;
      this.readNumber = readNumber;
      this.insuranceInfoData = messageEventInfo;
      if (messageEventInfo['processingStatus'] === 'FAIL') {
        let failureReason = JSON.parse(messageEventInfo['failureReason']);
        this.insuranceInfoData['failureReason'] = failureReason.message ? failureReason.message : '';
      }
      this.dataSource = {
        INTERNAL_MAIL: messageDetail.INTERNAL_MAIL ? messageDetail.INTERNAL_MAIL.map(item => {
          if (item.readingStatus === 0) {
            item.readingStatus = '未读';
          } else if (item.readingStatus === 1) {
            item.readingStatus = '已读';
          }
          return item;
        }) : [],
        NOTE: messageDetail.NOTE || [],
        EMAIL: messageDetail.EMAIL || []
      };
    }
  }
};